import React, { useContext, useEffect, useState } from "react";
import { QuoteContext } from "./QuoteContext";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";

const Age = () => {
  const { formValues, updateFormValues, nextStep, prevStep } = useContext(QuoteContext);
  const [ages, setAges] = useState(
    formValues.ages?.length ? formValues.ages : [""]
  ); // Load stored ages or default

  useEffect(() => {
    if (formValues.coverage === "individual") {
      setAges((prevAges) =>
        prevAges.length === 1 ? prevAges : [prevAges[0] || ""]
      ); // Keep old value if available
    } else if (formValues.coverage === "family") {
      const familyCount = formValues.familyMembers
        ? parseInt(formValues.familyMembers)
        : 2;
      setAges((prevAges) => {
        let newAges = new Array(familyCount)
          .fill("")
          .map((_, i) => prevAges[i] || "");
        return newAges;
      });
    }
  }, [formValues.coverage, formValues.familyMembers]); // Update when coverage changes

  const handleAgeChange = (index, value) => {
    if (value > 85 || value < 0 ) {
      toast.error("Please enter valid age values.");
      return;
    }
    const updatedAges = [...ages];
    updatedAges[index] = value;
    setAges(updatedAges);
    updateFormValues({ ages: updatedAges });
  };

  const handleNext = () => {
    if (ages.some((age) => !age || parseInt(age) <= 0 || parseInt(age) > 85 ) ) {
      toast.error("Please enter valid age values.");
      return;
    }
    updateFormValues({ ages });
    nextStep();
  };

  return (
    <div className="text-orangeColor flex p-10 justify-center space-y-5">
      <div className="w-full max-w-lg rounded-lg ">
      <div className="text-white text-[12px] mb-6">
      <span className="bg-[#1f4c75] font-thin px-4 py-1 rounded-full  pointer-events-none cursor-not-allowed">
          Age
        </span>
        </div>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-8">Who's Included?</h1>
        <p className="mb-6 text-gray-300  sm:text-[20px]">
          Add ages for everyone who needs coverage.
        </p>

        <AnimatePresence>
          {ages.map((age, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              className="mb-4 flex-col xs:flex-row flex xs:items-center xs:justify-between gap-1  xs:gap-4 sm:gap-10 md:gap-16"
            >
              <label className="text-gray-300 sm:text-[16px] text-[12px]">
                {index === 0
                  ? "Primary Member's Age:"
                  : `Member ${index + 1} Age:`}
              </label>
              <input
                type="number"
                min="1"
                max='85'
                value={age}
                onChange={(e) => handleAgeChange(index, e.target.value)}
                placeholder="eg. 23"
                className="px-6 py-2 xs:w-64 rounded-xl bg-[#001F3F] text-white placeholder-gray-400 border border-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FFA726]"
              />
            </motion.div>
          ))}
        </AnimatePresence>

        <div className="flex justify-end gap-6 mt-6">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={prevStep}
            className="bg-gray-500 text-white mt-8 py-3 md:py-3 md:px-6 px-4 rounded-xl hover:bg-gray-600 transition-all"
          >
            Back
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleNext}
            className="bg-orangeColor text-white mt-8 py-3 md:py-3 md:px-6 px-4 rounded-xl  hover:bg-[#ff9800] transition-all"

          >
            Next Step →
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Age;






